function pad(n: number) { return String(n).padStart(2, '0'); }

export function fmtDuration(secs: number): string {
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

export function fmtViews(n: number): string {
  if (n >= 100_000) return `조회수 ${Math.round(n / 10000)}만회`;
  if (n >= 10_000)  return `조회수 ${(n / 10000).toFixed(1)}만회`;
  if (n >= 1_000)   return `조회수 ${(n / 1000).toFixed(1)}천회`;
  return `조회수 ${n}회`;
}

export function fmtRel(d: Date, now: Date = new Date()): string {
  const diff = (now.getTime() - d.getTime()) / 1000;
  if (diff < 60)         return '방금 전';
  if (diff < 3600)       return `${Math.floor(diff / 60)}분 전`;
  if (diff < 86400)      return `${Math.floor(diff / 3600)}시간 전`;
  if (diff < 86400 * 7)  return `${Math.floor(diff / 86400)}일 전`;
  if (diff < 86400 * 30) return `${Math.floor(diff / (86400 * 7))}주 전`;
  if (diff < 86400 * 365)return `${Math.floor(diff / (86400 * 30))}개월 전`;
  return `${Math.floor(diff / (86400 * 365))}년 전`;
}

// "2026.05.10 09:00" — Korean time, no zone suffix.
export function fmtIndexed(d: Date): string {
  const kst = new Date(d.getTime() + 9 * 3600 * 1000);
  const y = kst.getUTCFullYear();
  const m = pad(kst.getUTCMonth() + 1);
  const day = pad(kst.getUTCDate());
  const hh = pad(kst.getUTCHours());
  const mm = pad(kst.getUTCMinutes());
  return `${y}.${m}.${day} ${hh}:${mm}`;
}
